import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .text {
    color: #898989;
    line-height: 1.5rem;
  }
`